import React from 'react';

export default function PlaceSetting({selected}) {
	if (selected) {
		return (
			<div id="display-container" style={selected.table ? {backgroundImage: 'url(' + selected.table.image + ')'} : null}>
				<div id="display-wrapper">
					<div id="charger">
						<img className="img-responsive" src={selected.charger ? selected.charger.image : null}/>
					</div>
					<div id="dinner">
						<img className="img-responsive" src={selected.dinner ? selected.dinner.image : null}/>
					</div>
					<div id="salad">
						<img className="img-responsive" src={selected.salad ? selected.salad.image : null}/>
					</div>
				</div>
			</div>
		);
	}
	return null;
}